<template>
    <div class="box-text">
        <van-cell center :title="item.title" :value="item.data" />
    </div>
</template>
<script>
import Vue from 'vue';
import { Icon,Cell } from 'vant';
Vue.use(Cell);
Vue.use(Icon);
export default {
    name:"Radio",
    props:{
        item:{
            type:Object
        }
    },
    data(){
        return{

        }
    }
}
</script>
<style lang="less">

</style>